function pdfBlobUrl(buffer) {
	const blob = new Blob([buffer], { type: 'application/pdf' });
	return URL.createObjectURL(blob);
}

export default pdfBlobUrl;
